import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=d38d910c&scoped=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=d38d910c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38d910c",
  null
  
)

export default component.exports